<template>
  <div>
  <Dialog :title="$t('Producto')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="validationObserver">
        <v-form ref="form" lazy-validation class="pa-1">
          <v-tabs v-model="active_tab" class="elevation-2" grow>
            <!-- Cabecera del tab Datos básicos -->
            <v-tab href="#tab-datosbasico">
              <span class="tab_title">
                {{ $t("Datos básicos") }}
              </span>
            </v-tab>

            <!-- Cabecera del tab Proveedor -->
            <v-tab href="#tab-proveedor">
              <span class="tab_title">
                {{ $t("Proveedor") }}
              </span>
            </v-tab>

            <!-- Cabecera del tab Online -->
            <v-tab href="#tab-ecommerce">
              <span class="tab_title">
                {{ $t("Ecommerce") }}
              </span>
            </v-tab>

            <!-- Cabecera del tab Histórico -->
            <v-tab href="#tab-historico" v-if="producto.id">
              <span class="tab_title">
                {{ $t("Histórico") }}
              </span>
            </v-tab>

            <!-- Cabecera del tab Escandallo -->
            <v-tab href="#tab-escandallo">
              <span class="tab_title">
                {{ $t("Escandallo") }}
              </span>
            </v-tab>

            <v-tab v-if="centro.is_central" href="#tab-transferencia">
              <span class="tab_title">
                {{ $t("Transferencia") }}
              </span>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="active_tab" class="elevation-2" touchless>
            <v-tab-item value="tab-datosbasico" class="pa-4 grey lighten-5">
              <!-- CÓDIGO DE BARRAS FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      v-model="producto.barcode"
                      :label="$t('Código de barras')"
                      hide-details
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- FIN CÓDIGO DE BARRAS FIELD -->

              <!-- REFERENCIA FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      hide-details
                      v-model="producto.ref"
                      :label="$t('Referencia')"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- FIN REFERENCIA FIELD -->

              <!-- NOMBRE FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Nombre').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-text-field
                          hide-details
                          v-model="producto.nombre"
                          :label="$t('Nombre')"
                          outlined
                          dense
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN NOMBRE FIELD -->

              <!-- CATEGORÍA FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="11" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Categoría').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-autocomplete
                          hide-details
                          :label="$t('Categoría')"
                          v-model="producto.categoria"
                          :items="data_form.categorias"
                          :no-data-text="$t('No hay datos')"
                          dense
                          outlined
                      ></v-autocomplete>
                    </div>
                    <span class="error--text pa-0">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
                <v-col class="d-flex pa-0 align-center justify-center">
                  <v-btn
                      fab
                      depressed
                      x-small
                      color="primary"
                      :title="$t('Nueva categoría')"
                      @click="click_nueva_categoria"
                  >
                    <v-icon small>mdi-auto-fix</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <!-- FIN CATEGORÍA FIELD -->

              <!-- CENTROS FIELD -->
              <v-row class="ma-0 mt-3" v-if="data_form.centros">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Centros').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <CustomSelect
                          :label="$t('Centros')"
                          v-model="producto.centros"
                          :items="data_form.centros"
                      />
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN CENTROS FIELD -->

              <!-- STOCK FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider :rules="{required: true,  integer: true}"
                                      :name="$t('Stock').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          :label="$t('Stock')"
                          v-model="producto.stocks.existencias"
                          :outlined="true"
                          :dense="true"
                          type="number"
                          :readonly="!can_modificar_stock"
                      />
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN STOCK FIELD -->

              <!-- PRECIO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Precio').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          v-model="producto.precio"
                          :label="$t('Precio')"
                          type="number"
                          :outlined="true"
                          :dense="true"
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN PRECIO FIELD -->

              <!-- IMPUESTO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Impuesto').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-autocomplete
                          hide-details
                          :label="$t('Impuesto')"
                          v-model="producto.impuesto"
                          :items="data_form.impuestos"
                          :no-data-text="$t('No hay datos')"
                          dense
                          outlined
                      ></v-autocomplete>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN IMPUESTO FIELD -->

              <!-- USO INTERNO FIELD -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="producto.is_uso_interno"
                      :label="$t('Uso interno')"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- FIN USO INTERNO FIELD -->

              <!-- ACTIVO FIELD -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="producto.is_active"
                      :label="$t('Activo')"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- ACTIVO FIELD -->
            </v-tab-item>

            <!-- Contenido del tab Proveedor -->
            <v-tab-item value="tab-proveedor" class="pa-4 grey lighten-5">
              <!-- PROVEEDOR FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <v-autocomplete
                      hide-details
                      :label="$t('Proveedor')"
                      v-model="producto.proveedor"
                      :items="data_form.proveedores"
                      :no-data-text="$t('No hay datos')"
                      dense
                      outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <!-- FIN PROVEEDOR FIELD -->

              <!-- PEDIDO MÍNIMO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider :rules="{required: true, integer: true, min_value: 0}"
                                      :name="$t('Pedido mínimo').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          :label="$t('Pedido mínimo')"
                          class="mb-1"
                          v-model="producto.pedido_minimo"
                          outlined
                          dense
                          type="number"
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN PEDIDO MÍNIMO FIELD -->

              <!-- STOCK MÍNIMO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider :rules="{required: true, integer: true, min_value: 0}"
                                      :name="$t('Stock mínimo').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          :label="$t('Stock mínimo')"
                          class="mb-1"
                          v-model="producto.stocks.stock_minimo"
                          outlined
                          dense
                          type="number"
                          :readonly="!can_modificar_stock"
                      />
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN STOCK MÍNIMO FIELD -->

              <!-- PRECIO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Precio coste').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          v-model="producto.precio_coste"
                          :label="$t('Precio coste')"
                          type="number"
                          :outlined="true"
                          :dense="true"
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN PRECIO FIELD -->
            </v-tab-item>

            <!-- Contenido del tab Ecommerce -->
            <v-tab-item value="tab-ecommerce" class="pa-4 grey lighten-5">
              <!-- PRECIO ONLINE FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Precio').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          v-model="producto.precio_online"
                          :label="$t('Precio online')"
                          type="number"
                          :outlined="true"
                          :dense="true"
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN PRECIO ONLINE FIELD -->

              <!-- DETALLE FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <v-textarea
                      :label="$t('Detalle')"
                      v-model="producto.detalle"
                      outlined
                      dense
                  ></v-textarea>
                </v-col>
              </v-row>
              <!-- FIN DETALLE FIELD -->

              <!-- DISPONIBLE ECOMMERCE -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      dense
                      :label="$t('Disponible en ecommerce')"
                      class="ma-0 my-1"
                      v-model="producto.is_disponible_ecommerce"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- FIN DISPONIBLE ECOMMERCE -->

              <v-card class="mb-5" elevation="0" v-if="producto.id">
                <v-card-title class="grey--text text--darken-2">{{ $t('Imágenes') }}</v-card-title>
                <v-card-text class="grey lighten-5">
                  <Imagenes :imagenes="producto.imagenes" :id="producto.id" @on_change="update_images"/>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Contenido del tab Histórico -->
            <v-tab-item value="tab-historico" class="pa-4 grey lighten-5">
              <TablaMovimientosStock
                  :selected_filters="{producto__in: [producto.id]}"
                  :show_column_producto="false"
              />
            </v-tab-item>

            <!-- Contenido del tab Escandallo -->
            <v-tab-item value="tab-escandallo" class="pa-4 grey lighten-5">
              <v-row>
                <v-col cols="12" class="pa-0">
                  <div class="container_info_azul ma-0">
                    <p>
                      {{ $t('Selecciona los servicios en los que este producto se puede utilizar de uso interno. Cuando se haga una venta de los servicios al que pertenece, este producto se mostrará para poder descontar el stock.') }}
                    </p>
                  </div>
                </v-col>
              </v-row>

              <v-row class="ma-3">
                <v-col cols="12" class="pa-0 text-center">
                  <v-chip
                      v-for="(current_servicio, index) in servicios_escandallo_seleccionados"
                      :key="index"
                      class="ma-2"
                      small
                      close
                      dark
                      color="green"
                      @click:close="add_servicio_to_escandallo(current_servicio)"
                  >
                    {{ current_servicio.nombre  }}
                  </v-chip>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <Buscador @search="get_servicios"/>
                  <v-data-table
                      :headers="tabla.headers"
                      :items="tabla.servicios"
                      :options.sync="tabla.options"
                      :server-items-length="tabla.count"
                      :fixed-header="true"
                      class="elevation-3"
                      calculate-widths
                      :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
                  >
                    <template v-slot:item="{ item }">
                      <tr @click="add_servicio_to_escandallo(item)" :class="get_escandallo_class(item)">
                        <td>{{ item.nombre }}</td>
                        <td>{{ item.categoria.nombre }}</td>
                        <td>{{ item.precio }} {{ $store.state.centro.centro.divisa.simbolo }}</td>
                        <td>{{ item.duracion }}</td>
                        <td>{{ item.ref }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="tab-transferencia" class="pa-4 grey lighten-5">
              <v-row class="ma-3">
                <v-col cols="4">
                  <v-select
                      :label="$t('Centro de origen')"
                      outlined dense hide-details
                      v-model="transferencia.centro_origen"
                      :items="data_form.centros"
                      item-disabled="transfer_disabled"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                      :label="$t('Centro de destino')"
                      outlined dense hide-details
                      v-model="transferencia.centro_destino"
                      :items="data_form.centros"
                      item-disabled="transfer_disabled"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    :label="$t('Cantidad')"
                    type="number"
                    outlined dense hide-details
                    v-model="transferencia.cantidad"
                  />
                </v-col>
                <v-col cols="1">
                  <v-btn icon color="primary" :title="$t('Transferir')" @click="click_transferir">
                    <v-icon large>
                      mdi-transfer
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </ValidationObserver>
    </template>
    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary ml-2" :disabled="!allow_save">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>
  </Dialog>

  <FormCategoria
      v-if="dialog_categoria"
      v-model="dialog_categoria"
      @on_save="on_save_categoria"
      method_save="categorias/save"
  />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'FormProducto',
  props: ['value', 'item'],
  data: () => {
    return {
      producto: {},
      data_form: {},
      // Variable para la gestión de los chips
      servicios_escandallo_seleccionados: [],
      // Model para los tabs del formulario en la validación
      active_tab: "tab-datosbasico",
      tabla: {
        servicios: [],
        count: 0,
        headers: [],
        filtros: {},
        options: {
          itemsPerPage: localStorage.getItem('itemsPerPage') ? parseInt(localStorage.getItem('itemsPerPage')) :  10
        }
      },
      dialog_categoria: false,
      transferencia: {
        centro_origen: null,
        centro_destino: null,
        cantidad: 0,
        centros: []
      }
    }
  },

  methods: {
    /**
     * Recuperar los datos necesarios para pintar el formulario del producto
     * @returns {Promise<void>}
     */
    async get_data_form() {
      try {
        this.data_form = await this.$store.dispatch('producto/get_form')
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },

    /**
     * Recupera los servicios de la api
     */
    async get_servicios(search = null) {
      if(search)
        this.tabla.filtros['search'] = search
      let filtros = { ...this.tabla.filtros }
      filtros['is_active'] = true

      try{
        const response = await this.$store.dispatch("servicio/get_servicios", {
          params: filtros
        });
        this.tabla.servicios = response.results;
        this.tabla.count = response.count;
      } catch (err){
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },

    /**
     * Recupera el detalle de los servicios del escandallo
     */
    async get_servicios_escandallo_seleccionados(){
      if(this.producto.servicios_escandallo.length === 0) return

      try{
        const response = await this.$store.dispatch('servicio/get_servicios', {
          params: {
            id__in: this.producto.servicios_escandallo.join(",")
          }
        })
        this.servicios_escandallo_seleccionados = response.results
      }catch (err){}
    },

    /**
     * Agrega un servicio al escandallo
     * @param servicio
     */
    async add_servicio_to_escandallo(servicio) {
      //Comprobamos si existe el servicio
      const exist = (this.producto.servicios_escandallo.filter((el) => el === servicio.id)).length > 0

      if(!exist){
        // Si no existe, lo añadimos al producto
        this.producto.servicios_escandallo.push(servicio.id)
        // y al chip
        this.servicios_escandallo_seleccionados.push({
          id: servicio.id,
          nombre: servicio.nombre
        })
      }else{
        // Si no existe lo eliminamos del producto
        this.producto.servicios_escandallo = this.producto.servicios_escandallo.filter((el) => el !== servicio.id)
        // y del chip
        this.servicios_escandallo_seleccionados = this.servicios_escandallo_seleccionados.filter((el) => el.id !== servicio.id)
      }
    },

    /**
     * Devuelve la clase correspondiente de la tabla escandallo
     * @param item
     * @returns {string}
     */
    get_escandallo_class(item) {
      for (let servicio of this.producto.servicios_escandallo) {
        if (servicio === item.id)
          return "green";
      }
      return "";
    },

    /**
     * Guarda el producto
     * @returns {Promise<void>}
     */
    async save() {
      const form_valid = await this.$refs.validationObserver.validate()

      if (form_valid) {
        try {
          const producto = await this.$store.dispatch('producto/save', this.producto)
          this.$snotify.success(
            this.$t("Acción realizada con éxito"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.$emit('on_save', {
            producto: producto
          })
        } catch (err) {
          this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      } else {
        // Si hay error en una tab no activa no se va a esa tab y parece que el boton no hace nada.
        // Así al menos hay feedback al pulsar el botón
        this.active_tab = 'tab-datosbasico'
      }
    },

    /**
     * Actualiza las imágenes del producto después de guardarla
     * @returns {Promise<void>}
     */
    async update_images(){
      try {
        const producto_temp = await this.$store.dispatch('producto/get_producto', this.producto.id)
        this.producto.imagenes = producto_temp.imagenes
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    async on_save_categoria() {
      this.dialog_categoria = false
      await this.get_data_form()
    },

    click_nueva_categoria() {
      this.dialog_categoria = true
    },

    async click_transferir() {
      const payload = {
        producto: this.producto.id,
        params: this.transferencia
      }
      try {
        await this.$store.dispatch('producto/transferir', payload)
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
      this.$emit('on_transfer')
    },
  },

  created() {
    this.producto = {...this.item }
    if(!this.producto.id){
      this.producto.is_active = true
      this.producto.servicios_escandallo = []
      this.producto.impuesto = this.$store.state.centro.centro.impuesto_productos
      this.producto.precio = 0
      this.producto.stocks = {
        existencias: 0,
        stock_minimo: 0
      }
      this.producto.pedido_minimo = 1
      this.producto.precio_coste = 0
      this.producto.centros = [this.$store.state.centro.centro.id]
    }

    this.tabla.headers = [
      { text: this.$t("Nombre"), value: "nombre", class: "primary white--text", width: "30%" },
      { text: this.$t("Categoría"), value: "categoria.nombre", class: "primary white--text" },
      { text: this.$t("Precio"), value: "precio", class: "primary white--text" },
      { text: this.$t("Duración"), value: "duracion", class: "primary white--text" },
      { text: this.$t("Referencia"), value: "ref", class: "primary white--text" }
    ]
    this.get_data_form()
    this.get_servicios_escandallo_seleccionados()
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    can_modificar_stock() {
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("modificar_stock")) {
          return true
        }
      }
      return false
    },
    centro(){
      return this.$store.state.centro.centro
    },
    allow_save(){
      return !(this.centro.is_productos_compartidos && !this.centro.is_central);
    },
  },

  watch: {
    'tabla.options': {
      handler(value, oldValue){
        if(value.itemsPerPage !== oldValue.itemsPerPage){
          try{
            localStorage.setItem('itemsPerPage', value.itemsPerPage)
          }catch (e){}
        }
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_servicios()
      },
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    Imagenes: () => import('@/components/shared/Imagenes'),
    FormCategoria: () => import('@/views/Configuracion/Categorias/FormCategoria.vue'),
    TablaMovimientosStock: () => import("@/views/Configuracion/Productos/MovimientosStock/TablaMovimientosStock")
  }
}
</script>
